import { Phone, Lock } from "lucide-react";

export default function LoginSample({ p, font }) {
  return (
    <div className="w-[390px] max-w-full mx-auto rounded-[2.6rem] border-[10px] border-black overflow-hidden shadow-2xl relative min-h-[760px] text-white" style={{ fontFamily: `'${font}', sans-serif`, background: p.primary }} data-testid="sample-login">
      <img src="/img/kuwait-night.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
      <div className="absolute inset-0" style={{ background: `linear-gradient(to bottom, ${p.primary}80, ${p.primary}F2 60%)` }} />
      <div className="relative px-6 pt-12 flex flex-col items-center">
        <img src="/img/logo.png" alt="شعار الشركة" className="w-40 h-40 rounded-full bg-white p-1.5 object-contain shadow-2xl" style={{ boxShadow: `0 0 0 4px ${p.accent}` }} />
        <h2 className="text-2xl font-black mt-5">المحيط الأطلسي</h2>
        <p className="text-white/70 text-sm">لنقل البضائع والمعدات</p>
        <div className="w-full mt-8 rounded-3xl bg-white/10 backdrop-blur-md border border-white/15 p-5 space-y-3">
          <div className="flex items-center gap-2 rounded-xl bg-white text-slate-500 px-3 h-14 whitespace-nowrap text-sm"><Phone className="w-5 h-5" />رقم الهاتف أو اسم المستخدم</div>
          <div className="flex items-center gap-2 rounded-xl bg-white text-slate-500 px-3 h-14"><Lock className="w-5 h-5" />كلمة المرور</div>
          <div className="h-14 rounded-xl flex items-center justify-center text-lg font-black" style={{ background: `linear-gradient(90deg, ${p.accent2}, ${p.accent})`, color: p.onAccent }}>تسجيل الدخول</div>
          <div className="text-center text-sm text-white/80">نسيت كلمة المرور؟</div>
        </div>
      </div>
    </div>
  );
}
